import { PROVIDER_LIST, ROOT, ALL_ROUTES_VALUES } from './routeTemplates';

export const NAVBAR_ITEMS = {
  DEPOSIT: 'deposit',
  REGISTRATION: 'registration',
  LOGIN: 'login',
  BACK: 'back',
  TITLE: 'title',
  SEARCH: 'search',
  FAVORITES: 'favorites',
  FILTER: 'filter',
};

export const NAVBAR_ITEMS_TO_SUBSCRIBE = [
  NAVBAR_ITEMS.FAVORITES,
  NAVBAR_ITEMS.FILTER,
];

export const NAVBAR_EVENT_METHODS = {
  SUBSCRIBE: 'subscribe',
  UPDATE: 'batchUpdate',
};

export const ROUTES_WITH_BACK_BUTTON = ALL_ROUTES_VALUES;
export const ROUTES_WITH_TITLE = ALL_ROUTES_VALUES;

export const ROUTES_WITH_FAVORITES = [ROOT];

export const ROUTES_WITH_SORTING_ICON = [PROVIDER_LIST];
